import type { FC, PropsWithChildren } from 'react';
import { Box, type BoxProps } from '@mui/material';

export type RootLayoutProps = PropsWithChildren<BoxProps>;

export const RootLayout: FC<RootLayoutProps> = ({ children, ...props }) => (
  <Box
    sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
    {...props}>
    {children}
  </Box>
);
